if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        // Ensure variant input isn't disabled
        const variantInput = this.variantIdInput;
        if (variantInput) variantInput.disabled = false;

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.error = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      getCartUI() {
        // Re-check at runtime. Prefer cart-drawer.
        const drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
        const notification =
          document.querySelector('cart-notification') || document.getElementById('CartNotification');
        return drawer || notification || null;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        // Use theme fetchConfig if it exists; otherwise create a safe default
        const config =
          typeof window.fetchConfig === 'function'
            ? window.fetchConfig('javascript')
            : { method: 'POST', headers: { Accept: 'application/json' } };

        config.method = 'POST';
        config.headers = config.headers || {};
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        // FormData => do not set Content-Type
        if (config.headers['Content-Type']) delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const cartUI = this.getCartUI();

        // If we have a cart drawer/notification with section rendering support, request sections.
        if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cartUI.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);

          if (typeof cartUI.setActiveElement === 'function') {
            cartUI.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;

        const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

        fetch(cartAddUrl, config)
          .then((r) => r.json())
          .then((response) => {
            if (response && response.status) {
              // Optional pubsub error
              if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartError) {
                window.publish(window.PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }

              this.handleErrorMessage(response.description || response.message || response.errors);
              this.error = true;
              return;
            }

            const cartUIAfter = this.getCartUI();

            // If there is NO drawer/notification at all, do NOT force redirect.
            // (Your requirement: open drawer instead of navigating.)
            if (!cartUIAfter) {
              // At least the item is added; leave user on page.
              this.error = false;
              return;
            }

            // Ensure drawer isn't stuck in empty mode
            if (cartUIAfter.classList && cartUIAfter.classList.contains('is-empty')) {
              cartUIAfter.classList.remove('is-empty');
            }

            // Render updated drawer/notification if supported
            if (typeof cartUIAfter.renderContents === 'function') {
              cartUIAfter.renderContents(response);
            }

            // If it's a drawer and has open(), open it
            const drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
            if (drawer && typeof drawer.open === 'function') {
              drawer.open();
            }

            this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.classList.remove('loading');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            }

            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent =
            typeof errorMessage === 'string' ? errorMessage : JSON.stringify(errorMessage);
        }
      }

      get variantIdInput() {
        if (!this.form) return null;
        return this.form.querySelector('[name="id"]');
      }
    }
  );
}
